export function trimObjectStrings<T>(obj: T): T {
    if (Array.isArray(obj)) {
        return obj.map(trimObjectStrings) as unknown as T;
    }
    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([k, v]) => [k, trimObjectStrings(v)])
        ) as T;
    }
    if (typeof obj === 'string') {
        return obj.trim() as unknown as T;
    }
    return obj;
}
